module.exports = __webpack_public_path__ + "static/media/nbths.d9bc220d.png";